import { ServiceHandler } from '../../../utils/api.utils';
import type { FileUploadResponse } from '../types';

export const uploadFile = ServiceHandler<FormData, FileUploadResponse>({
  url: '/api/chat-agent/v1/files/upload',
  method: 'POST',
});
